import React, { useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { Container, Row, Col } from 'react-grid-system';
import log from "Utils/logger";

import Tabs from 'SharedComponents/tabs';
import SignInForm from 'SharedComponents/sign-in-form';
import ShareStrip from 'SharedComponents/share-strip';
import ContactInfoForm from 'SharedComponents/contact-info-form';
import PasswordForm from './PasswordForm';
import ActivityLog from './ActivityLog';
import SelectSubscriptionPlan from 'SharedComponents/select-subscription';

import style from './index.css';

import useFetchActivityLogs from 'SharedHooks/fetch-activity-logs';
import useFetchRoundUpsShopperData from 'SharedHooks/fetch-roundups-shopper-data';
import useFetchShopperProfile from 'SharedHooks/fetch-shopper-profile';

const AccountWrapper = styled.div`${style}`;

const Account = () => {
  const authentication = useSelector((state) => state.authentication);
  const [searchParams] = useSearchParams();

  const { isFetchingActivityLogs, fetchActivityLogs } = useFetchActivityLogs(); // Use the custom hook
  const { fetchRoundUpsShopperData } = useFetchRoundUpsShopperData();
  const { fetchShopperProfile } = useFetchShopperProfile();
  
  console.log ('**Account function triggered with authentication:', authentication);

  useEffect(() => {
    console.log('**Account useEffect triggered - HELLO');
    if (authentication && authentication.user.shopper_id && !isFetchingActivityLogs) { 
      console.log('**Account useEffect about to fetchActivityLogs');
      fetchActivityLogs();
    }
  }, [authentication.user.shopper_id ]);

  const initialTab = searchParams.get("tab");
  console.log('account - initialTab:', initialTab);

  const [activeTab, setActiveTab] = useState( initialTab || 
    ('current-plan'));
  
  useEffect(() => {

    const currentUrlTab = new URL(window.location).searchParams.get("tab");
    console.log('account - useEffect - activeTab triggered with NEW activeTab: ', activeTab);
    console.log('account - useEffect - activeTab triggered with OLD currentUrlTab: ', currentUrlTab);

    if (currentUrlTab !== activeTab) {
      console.log('partnerships - useEffect - activeTab EXECUTING to set url to activeTab: ', activeTab);
      const url = new URL(window.location);
      url.searchParams.set('tab', activeTab);
      window.history.replaceState({}, '', url);
    }


  }, [activeTab]);

  const onActiveTabChanged = (newActiveTab) => setActiveTab(newActiveTab);

  if (!authentication.user) {
    return (
      <AccountWrapper>
        <div style={{ maxWidth: 600, padding: 10, width: 'calc(100% - 20px)', height: '100%' }}>
          <SignInForm
            showEmailLogin
            header={(
              <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start' }}>
                <h1>Login</h1>
                <span>To access your account</span>
              </div>
            )}
            showSocialLogin
          />
        </div>
      </AccountWrapper>
    );
  }

  return (
    <AccountWrapper>
      <ShareStrip />
      <div className="content">
        <Tabs
          onActiveTabChanged={onActiveTabChanged}
          activeTab={activeTab}
          tabs={[
            {
              label: 'Your Plan',
              value: 'current-plan',
            },
            {
              label: 'About You',
              value: 'about-you',
            },
            {
              label: 'Account History',
              value: 'activity-log',
            }
          ]}
        />
        {activeTab === 'about-you' && (
          <div style={{ width: '100%' }}>
            <Container fluid className="links-container" style={{ margin: 0, padding: 0, width: '100%' }}>
              <Row style={{ margin: 0, padding: 0, width: '100%' }}>
                <Col xl={6} lg={6} md={6} sm={12} xs={12} className="links-group" style={{ margin: 0, padding: 0 }}>
                  <ContactInfoForm />
                </Col>
                {authentication.user.signup_method === 'email' && (
                  <Col xl={6} lg={4} md={6} sm={12} xs={12} className="links-group" style={{ margin: 0, padding: 0 }}>
                    <PasswordForm />
                  </Col>
                )}
              </Row>
            </Container>
          </div>
        )}
        {activeTab === 'activity-log' && (
          <div style={{ width: 'calc(100% - 20px)', padding: 10 }}>
            <ActivityLog
              activityLogs={authentication.activityLogs} 
              isFetchingActivityLogs={isFetchingActivityLogs} 
            />
          </div>
        )}
        {activeTab === 'current-plan' && (
          <div style={{ width: 'calc(100% - 20px)', padding: 10 }}>
                <Container fluid className="links-container" style={{ margin: 0, padding: 0, width: '100%' }}>
                  <Row style={{ margin: 0, padding: 0, width: '100%' }}>
                    <Col xl={6} lg={6} md={6} sm={12} xs={12} className="links-group" style={{ margin: 0, padding: 0 }}>
                    <div className="acceptance-card">
                      <h2 className="title">Update Subscription Plan</h2>
                      <SelectSubscriptionPlan
                        subscriptionFeaturesOn={true}
                      />
                    </div>

                    </Col>
                  </Row>
                </Container>
          </div>
        )}
      </div>
    </AccountWrapper>
  );
};

export default Account;


